import {RootState} from 'redux/store'

export const selectLastSavedSearch = (state: RootState) => state.settingsRoot.last_saved_search
export const selectLastProjectId = (state: RootState) => state.settingsRoot.last_project_id
